import DeliveryNotificationMessagesEdit from '@/views/DeliveryNotificationMessages/Edit.vue';
import DeliveryNotificationMessagesIndex from '@/views/DeliveryNotificationMessages/Index.vue';
import Settings from '@/views/Settings/Settings.vue';
import UpdateList from '@/views/Update/UpdateList.vue';
import WhatsAppAccounts from '@/views/WhatsAppAccounts/WhatsAppAccounts.vue';
import WhatsAppAccountsCreate from '@/views/WhatsAppAccounts/WhatsAppAccountsCreate.vue';
import WhatsAppAccountsEdit from '@/views/WhatsAppAccounts/WhatsAppAccountsEdit.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import ComboEdit from '../views/Combo/ComboEdit';
import ComboList from '../views/Combo/ComboList';
import Home from '../views/Home.vue';
import PromoCreate from '../views/Promo/PromoCreate';
import PromoEdit from '../views/Promo/PromoEdit';
import PromoList from '../views/Promo/PromoList';

Vue.use(VueRouter);

const routes = [
  {
    name: 'Home',
    path: '*',
    component: Home,
  },
  {
    name: 'Combo',
    path: '/combo',
    component: ComboList,
  },
  {
    name: 'ComboEdit',
    path: '/combo/edit/:id',
    component: ComboEdit,
    props: true,
  },
  {
    name: 'Promo',
    path: '/promo',
    component: PromoList,
  },
  {
    name: 'PromoCreate',
    path: '/promo/create',
    component: PromoCreate,
  },
  {
    name: 'PromoEdit',
    path: '/promo/edit/:id',
    component: PromoEdit,
    props: true,
  },
  {
    name: 'Update',
    path: '/updates',
    component: UpdateList,
  },
  {
    name: 'Settings',
    path: '/settings',
    component: Settings,
  },
  {
    name: 'WhatsAppAccounts',
    path: '/whatsapp-accounts',
    component: WhatsAppAccounts,
  },
  {
    name: 'WhatsAppAccountsCreate',
    path: '/whatsapp-accounts/create',
    component: WhatsAppAccountsCreate,
  },
  {
    name: 'WhatsAppAccountsEdit',
    path: '/whatsapp-accounts/edit/:id',
    component: WhatsAppAccountsEdit,
    props: true,
  },
  {
    name: 'DeliveryNotificationMessagesIndex',
    path: '/delivery-notification-messages',
    component: DeliveryNotificationMessagesIndex,
  },
  {
    name: 'DeliveryNotificationMessagesEdit',
    path: '/delivery-notification-messages/edit/:id',
    component: DeliveryNotificationMessagesEdit,
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
